export function Cargando() {
    return (
        <>
            <div className="w-100 d-flex justify-content-center align-items-center col-12">
                <div className="custom_loader_flipping-square">
                    <h1></h1>
                </div>
            </div>

        </>

    )


}
